
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const BottomNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: 'ri-home-line', activeIcon: 'ri-home-fill', label: 'Home' },
    { path: '/categories', icon: 'ri-grid-line', activeIcon: 'ri-grid-fill', label: 'Categories' },
    { path: '/deals', icon: 'ri-fire-line', activeIcon: 'ri-fire-fill', label: 'Deals' },
    { path: '/wishlist', icon: 'ri-heart-line', activeIcon: 'ri-heart-fill', label: 'Wishlist' },
    { path: '/account', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: 'Account' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center space-y-1 transition-colors ${
                isActive ? 'text-emerald-500' : 'text-gray-500'
              }`}
            >
              <i className={`${isActive ? item.activeIcon : item.icon} text-lg`}></i>
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
